import { TimesheetReviewAlert } from "./TimesheetReviewAlert";

/**
 * Renders on `/unverified-timesheet` and the past-shift detail page when there
 * is a pending hours adjustment or pending missed-punch request. Frames the
 * outcome as additional pay upon approval.
 */
export function PastShiftAdjustmentTimesheetReviewAlert() {
  return (
    <TimesheetReviewAlert title="You are requesting a shift adjustment">
      Your request may be reviewed first. You&apos;ll receive a response within 3 business days, and
      your additional shift pay immediately upon approval.
    </TimesheetReviewAlert>
  );
}
